import './spinner/spinner.scss';
import spinLogo from "../../images/PeerEase_icon.png";
import Peerease from "../../images/PeerEase_Logo.png"

type props = {
    timeout?: number,
    type?: any
}

function WHSEtwoELoader({ timeout = 3000, type = 'Triangle' }: props) {
    return (
        <div className="loaderContainerE2E">
            <div className="custom-loader"></div>
            <div className='loader-center1'>
                <div style={{display: "flex"}}>
                <img src={spinLogo} alt="peerease spin" className='logo_spin' />
                <img src={Peerease} alt="peerease logo" />
                </div>
            <div className='loader-message'>
                <div style={{ fontWeight: "bolder"}}>Please wait a moment while we process your request.</div>
                <div style={{ fontWeight: "bolder"}}>This may take a few moments, so please do not close this window.</div>
            </div>
            </div>
        </div>
    )
}

export default WHSEtwoELoader;